import { ChatMessage } from "./ChatAIWS";
import UsersTable from "./ws/UsersTable";

export default function ChatRenderer({ message }: { message: ChatMessage }) {
    if (message.type === "users_result") {
        return <UsersTable data={message.data} />;
    }

    return <div>{message.response}</div>;
}
